module.exports = __webpack_public_path__ + "static/media/header.9a231668.png";